import React from 'react'
import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

export interface AppDrawerFooterProps {
  children?: React.ReactNode
  padding?: SxProps<Theme>
  sx?: SxProps<Theme>
}

const DEFAULT_PADDING: SxProps<Theme> = { px: 2, py: 1.25 }

const AppDrawerFooter: React.FC<AppDrawerFooterProps> = ({
  children,
  padding = DEFAULT_PADDING,
  sx,
}) => (
  <Box
    sx={[
      {
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 -4px 12px rgba(15,23,42,0.04)',
      },
      ...(Array.isArray(padding) ? padding : [padding]),
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Box>
)

export default AppDrawerFooter
